import OneUserC from '@components/search/OneUser';
import React from 'react';
import PropTypes from 'prop-types';

import { Wrapper, Title, Users } from './follows.styles';

export default function SuggestedFollows({ users }) {
  return (
    <Wrapper>
      <Title>Suggested accounts to follow</Title>
      <Users>
        {users ? (
          users.map((user) => <OneUserC key={user?._id} user={user} />)
        ) : (
          <h2>No users</h2>
        )}
      </Users>
    </Wrapper>
  );
}

SuggestedFollows.propTypes = {
  users: PropTypes.array,
};
